const SET_REPORTS = (state, reports) => {
  state.reports = reports
}

const SET_REPORT = (state, report) => {
  state.report = report

  if (state.report.source) {
    state.report.source.dossierItems = state.report.source['werkprocessen'].concat(state.report.source['kennisenvaardigheden'])
  }
}

const PUSH = (state, report) => {
  state.reports.push(report)
  state.report = {}
}

const UPDATE = (state, report) => {
  state.report.name = report.name
}

const REMOVE = (state, reportId) => {
  let idx = state.reports.findIndex(x => x.id === reportId)
  state.reports.splice(idx, 1)
}

const PATCH_COLUMNS = (state, columns) => {
  state.report.columns = columns
}

const RESET = (state) => {
  state.report = null
}

export default {
  PUSH,
  RESET,
  UPDATE,
  REMOVE,
  SET_REPORT,
  SET_REPORTS,
  PATCH_COLUMNS
}
